import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    filterContainer: {
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
        rowGap: '20px',
    },
    toggleGroup: {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        height: '35px',
        '& .Mui-selected': {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: `${theme.palette.primary.contrastText} !important`,
            '&:hover': {
                backgroundColor: `${theme.palette.primary.dark} !important`,
            },
        },
    },
    toggleButton: {
        height: '35px',
        width: '50%',
        padding: theme.spacing(1, 2),
        textTransform: 'none',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
    },
}));
